import {
  DEFAULT_THEME_MODE,
  isThemeMode,
  resolveTheme,
  type ThemeMode,
  type ThemePreference,
} from '@xtreed/academy-shared';

export { resolveTheme };
export type { ThemePreference };

export function tenantThemeMode(value: unknown): ThemeMode {
  return isThemeMode(value) ? value : DEFAULT_THEME_MODE;
}

export function applyThemeClass(theme: ThemePreference): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
}
